import { memo } from 'react';

export type ImageSearchProps = {
  similarToImage: string;
};

export const ImageUploadSearch = memo(({ similarToImage }: ImageSearchProps) => (
  <div
    data-testid="IMAGE_UPLOAD_SEARCH"
    className="pointer-events-none flex items-center gap-1.5 truncate rounded-4 bg-grey-4 pr-1.5 font-medium text-12 text-grey-12"
  >
    {/* biome-ignore lint/performance/noImgElement: src is base64 image */}
    <img
      src={similarToImage}
      // biome-ignore lint/a11y/noRedundantAlt: "Search by uploaded image" is a descriptive alt text
      alt="Search by uploaded image"
      className="h-6 w-6 rounded-4 object-cover [image-rendering:smooth]"
    />
    Uploaded image
  </div>
));

ImageUploadSearch.displayName = 'ImageUploadSearch';
